type LandingLocale = typeof import('../en/landing').default

const landing = {
	templates: {
		productLanding: {
			name: 'Landing de producto',
			description:
				'Una landing configurable para mostrar la plataforma {{brandName}}.',
		},
		homeClassic: {
			name: 'Inicio – Clásico',
			description:
				'Diseño tradicional con hero, beneficios, testimonios, preguntas frecuentes y CTA.',
		},
		homeSpotlight: {
			name: 'Inicio – Destacado',
			description:
				'Layout con foco en logros, logos y una llamada a la acción contundente.',
		},
		aboutStory: {
			name: 'Acerca de – Historia',
			description:
				'Cuenta la historia, valores y equipo con métricas de impacto.',
		},
		contactHub: {
			name: 'Contacto – Centro',
			description:
				'Ofrece múltiples vías de contacto, respuestas rápidas y una CTA clara.',
		},
	},
	pages: {
		product: {
			name: '{{brandName}} para equipos',
			description:
				'Descubre cómo {{brandName}} ayuda a los equipos a ofrecer experiencias de aprendizaje modernas.',
		},
	},
	template1: {
		hero: {
			title:
				'Facturación de contratos personalizados sin esfuerzo con brillance',
			subtitle:
				'Optimiza tu proceso de facturación con automatización perfecta para cada contrato personalizado, creada por brillance.',
			primaryCta: 'Comienza gratis',
			secondaryCta: 'Solicitar demo',
		},
		stats: {
			eyebrow: 'En cifras',
			title: 'Excelencia operativa a escala global',
			description:
				'Equipos de finanzas, operaciones y revenue confían en {{brandName}} para automatizar la facturación con fiabilidad.',
			items: {
				uptime: {
					value: '99,99%',
					label: 'Disponibilidad en los últimos 12 meses',
				},
				automations: {
					value: '120+',
					label: 'Automatizaciones lanzadas cada trimestre',
				},
				csat: {
					value: '4,9/5',
					label: 'Puntuación media de satisfacción del cliente',
				},
			},
		},
		logos: {
			title: 'Adoptado por equipos líderes',
			subtitle:
				'Desde startups en crecimiento hasta empresas globales, {{brandName}} impulsa operaciones de revenue modernas.',
			items: {
				brillance: {
					name: 'Brillance',
					tagline: 'Líder en automatización fintech',
				},
				lumen: {
					name: 'Lumen',
					tagline: 'Suite de analítica de producto',
				},
				velocity: {
					name: 'Velocity',
					tagline: 'Inteligencia logística',
				},
				apex: {
					name: 'Apex',
					tagline: 'Cloud bancario empresarial',
				},
			},
		},
		features: {
			title: 'Todo lo que necesitas para lanzar más rápido',
			subtitle:
				'Planifica, colabora y lanza más rápido con una plataforma hecha para equipos modernos.',
			items: {
				plan: {
					title: 'Planifica tus horarios',
					description:
						'Mantén cada iniciativa organizada con herramientas colaborativas de planificación.',
				},
				insights: {
					title: 'De los datos a los insights en minutos',
					description:
						'Convierte datos sin procesar en paneles confiables para todo el equipo.',
				},
				security: {
					title: 'Seguridad de nivel empresarial',
					description:
						'Protege los datos con SSO, roles granulares y auditorías.',
				},
			},
		},
		testimonials: {
			title: 'Escala con confianza',
			subtitle:
				'Equipos de múltiples industrias confían en {{brandName}} para automatizar la facturación sin perder control.',
			items: {
				casey: {
					quote:
						'Nuestro equipo financiero cerró el trimestre en horas, no días. La automatización funciona exactamente como la diseñamos.',
					author: 'Casey Morgan',
					role: 'VP de Finanzas, Brillance',
				},
				jordan: {
					quote:
						'La implementación fue sencilla. {{brandName}} se adapta a nuestros flujos y nos permite experimentar con seguridad.',
					author: 'Jordan Lee',
					role: 'Head of Revenue Operations, Velocity',
				},
			},
		},
		faq: {
			title: 'Preguntas frecuentes',
			description:
				'Todo lo que necesitas saber para lanzar facturación automatizada con {{brandName}}.',
			items: {
				billing: {
					question:
						'¿{{brandName}} puede manejar reglas complejas de facturación?',
					answer:
						'Sí. Usa lógica condicional, prorrateos y calendarios personalizados sin escribir código.',
				},
				implementation: {
					question: '¿Cuánto tarda la implementación?',
					answer:
						'La mayoría de los equipos lanzan en menos de tres semanas con soporte de nuestro equipo.',
				},
				security: {
					question: '¿Cómo protege {{brandName}} nuestros datos?',
					answer:
						'Incluye SSO, controles basados en roles, registros de auditoría y cifrado en reposo y en tránsito.',
				},
			},
		},
		pricing: {
			title: 'Planes flexibles para cada etapa',
			subtitle:
				'Elige el paquete que se ajuste a tu escala y actualiza cuando estés listo.',
			plans: {
				starter: {
					name: 'Starter',
					price: '149 $',
					period: 'al mes',
					description: 'Automatiza la facturación de una línea de producto.',
					features: {
						automation:
							'Constructor de flujos con bloques básicos de automatización',
						viewers: 'Hasta 10 visualizadores internos incluidos',
						support: 'Soporte por email con respuesta en 24 horas',
					},
					cta: 'Empieza la prueba gratis',
				},
				scale: {
					name: 'Scale',
					price: '499 $',
					period: 'al mes',
					description:
						'Coordina operaciones de revenue complejas entre equipos.',
					features: {
						automation: 'Automatización avanzada con lógica ramificada',
						crm: 'Integraciones nativas con CRM y sincronización de datos',
						success: 'Customer success dedicado',
					},
					cta: 'Habla con ventas',
				},
				enterprise: {
					name: 'Enterprise',
					price: 'Personalizado',
					period: 'contrato anual',
					description: 'Escala globalmente con controles y soporte avanzados.',
					features: {
						sso: 'Single sign-on para toda la organización',
						audit: 'Registros de auditoría completos y exportables',
						success: 'Cobertura de soporte prioritario 24/7',
					},
					cta: 'Contacta al equipo enterprise',
				},
			},
		},
		cta: {
			eyebrow: '¿Listo para automatizar?',
			title: 'Lanza flujos de facturación personalizados en semanas',
			description:
				'Colabora con nuestros especialistas para diseñar y desplegar facturación automatizada en tu stack.',
			primaryCta: 'Agenda una demo guiada',
		},
	},
	homeClassic: {
		hero: {
			title: 'Crea {{collectionEntityLabelPluralLower}} que tu equipo adore',
			subtitle:
				'Lanza {{mainEntityLabelPluralLower}} personalizad{{mainEntityGenderSuffixPlural}}, sigue el progreso y mantén a cada aprendiz comprometido desde el primer día.',
			primaryCta: 'Comienza gratis',
			secondaryCta: 'Ver recorrido del producto',
		},
		features: {
			title: 'Crea, organiza y lanza en tiempo récord',
			subtitle:
				'Todo lo necesario para ofrecer experiencias de aprendizaje modernas y con tu marca.',
			items: {
				builder: {
					title: 'Constructor visual de {{mainEntityLabelPluralLower}}',
					description:
						'Planifica currículos, módulos y sesiones en vivo con herramientas de arrastrar y soltar.',
				},
				library: {
					title: 'Biblioteca de contenido listo',
					description:
						'Combina {{mainEntityLabelPluralLower}} de expertos del marketplace con tus propios recursos.',
				},
				security: {
					question: '¿Qué tan rápido podemos salir a producción?',
					answer:
						'La mayoría de los equipos lanzan una academia con su marca en dos semanas usando plantillas base.',
				},
				integrations: {
					question: '¿{{brandName}} se integra con nuestro HRIS o LMS?',
					answer:
						'Sí. Conectores nativos y API sincronizan progreso, inscripciones y datos de usuarios.',
				},
				support: {
					question: '¿Qué soporte incluyen?',
					answer:
						'Todos los planes traen sesiones de onboarding y soporte por chat con especialistas.',
				},
			},
		},
		cta: {
			eyebrow: 'Conoce {{brandName}} en acción',
			title: 'Ofrece aprendizaje al que tu equipo vuelve una y otra vez',
			description:
				'Colabora con nuestros especialistas para diseñar tu primer{{mainEntityGenderSuffix}} {{mainEntityLabelLower}}.',
			primaryCta: 'Contactar ventas',
		},
	},
	homeSpotlight: {
		hero: {
			title: 'Donde los equipos ambiciosos crecen juntos',
			subtitle:
				'Ofrece experiencias de formación modernas con autoría visual, datos y automatización.',
			primaryCta: 'Reserva una demo',
		},
		stats: {
			eyebrow: 'Confianza global',
			title: 'Resultados que hablan por sí mismos',
			description:
				'{{brandName}} potencia {{collectionEntityLabelPluralLower}} para empresas de todos los tamaños.',
			items: {
				learners: {
					value: '250K+',
					label: 'Aprendices activos cada mes',
				},
				courses: {
					value: '12.000',
					label:
						'{{mainEntityLabelPlural}} lanzad{{mainEntityGenderSuffixPlural}} con plantillas de {{brandName}}',
				},
				rating: {
					value: '4,8/5',
					label: 'Puntuación media de satisfacción',
				},
			},
		},
		logos: {
			title: 'La plataforma preferida por líderes de su sector',
			subtitle:
				'Desde fintech hasta salud, {{brandName}} mantiene a los equipos preparados.',
			items: {
				alpha: {
					name: 'Alpha',
					tagline: 'Innovador en banca digital',
				},
				nova: {
					name: 'Nova',
					tagline: 'Inteligencia en salud',
				},
				pioneer: {
					name: 'Pioneer',
					tagline: 'Plataforma logística global',
				},
			},
		},
		cta: {
			eyebrow: '¿Te sumas?',
			title: 'Lanza tu próxima iniciativa de aprendizaje en semanas, no meses',
			description:
				'Elige una plantilla, personaliza el contenido y sal a producción con confianza.',
			primaryCta: 'Ver precios',
		},
	},
	aboutStory: {
		hero: {
			title: 'Existimos para que los equipos aprendan más rápido juntos',
			subtitle:
				'{{brandName}} nació de un grupo de diseñadores de aprendizaje que creen que el conocimiento debe viajar a velocidad startup.',
			primaryCta: 'Conoce al equipo',
		},
		stats: {
			eyebrow: 'Así es {{brandName}} hoy',
			title: 'Alcance global con una cultura centrada en las personas',
			description:
				'Colaboramos con equipos de aprendizaje de múltiples industrias y continentes.',
			items: {
				years: {
					value: '8 años',
					label:
						'Impulsando {{collectionEntityLabelPluralLower}} transformador{{collectionEntityGenderSuffixPlural}}',
				},
				team: {
					value: '180+',
					label: 'Integrantes {{brandName}} en 12 países',
				},
				clients: {
					value: '600+',
					label: 'Organizaciones construyendo con {{brandName}} en el mundo',
				},
			},
		},
		values: {
			title: 'Nuestros valores',
			subtitle: 'Crecemos apoyándonos en tres pilares fundamentales.',
			items: {
				innovation: {
					title: 'Innovar pensando en los aprendices',
					description:
						'Prototipamos sin parar para entregar experiencias memorables.',
				},
				people: {
					title: 'Personas primero',
					description:
						'Creemos que la cultura florece cuando cada persona se siente acompañada.',
				},
				impact: {
					title: 'Medir lo que importa',
					description:
						'Desde resultados hasta equidad, buscamos experiencias que dejen huella.',
				},
			},
		},
		faq: {
			title: 'Dentro de {{brandName}}',
			description: 'Un vistazo a cómo trabajamos.',
			items: {
				location: {
					question: '¿Dónde están ubicados?',
					answer:
						'Somos un equipo distribuido con hubs en Nueva York y Barcelona, y colegas en América, Europa y APAC.',
				},
				remote: {
					question: '¿Ofrecen roles remotos?',
					answer:
						'Sí. La mayoría de los puestos son remotos con encuentros opcionales en los hubs.',
				},
				culture: {
					question: '¿Cómo describen la cultura?',
					answer:
						'Combinamos alta autonomía con rituales colaborativos que nos mantienen alineados.',
				},
			},
		},
		cta: {
			eyebrow: 'Únete a nosotros',
			title: 'Construimos el futuro del aprendizaje—acompáñanos',
			description:
				'Explora vacantes o cuéntanos cómo {{brandName}} puede apoyar tu siguiente iniciativa.',
			primaryCta: 'Ver posiciones abiertas',
		},
	},
	contactHub: {
		hero: {
			title: 'Planifiquemos tu siguiente hito de aprendizaje',
			subtitle:
				'Ventas, Customer Success y producto están listos para ayudarte a diseñar la solución correcta.',
			primaryCta: 'Agenda una consulta',
		},
		methods: {
			title: 'Habla con nosotros como prefieras',
			subtitle:
				'Conéctate con el equipo {{brandName}} mediante cualquiera de estos canales.',
			items: {
				phone: {
					title: 'Llámanos',
					description:
						'Comunícate con un asesor de lunes a viernes, de 9h a 18h hora local.',
				},
				email: {
					title: 'Escríbenos',
					description:
						'Comparte los detalles del proyecto y responderemos en menos de un día hábil.',
				},
				meeting: {
					title: 'Agenda una videollamada',
					description:
						'Elige un horario para profundizar con un especialista de producto.',
				},
			},
		},
		faq: {
			title: 'Respuestas rápidas',
			description: 'Algunas aclaraciones antes de conectarnos.',
			items: {
				responseTime: {
					question: '¿Cuánto tardan en responder?',
					answer:
						'La mayoría de las consultas reciben respuesta en menos de 24 horas hábiles.',
				},
				sales: {
					question: '¿Hay prueba gratuita?',
					answer:
						'Sí. Todos los planes comienzan con una prueba guiada de 14 días.',
				},
				support: {
					question: '¿Cómo contacto soporte?',
					answer:
						'Los clientes pueden iniciar sesión y abrir un ticket o escribirnos por el chat en la plataforma.',
				},
			},
		},
		cta: {
			eyebrow: 'Estamos para ayudarte',
			title: 'Recibe orientación para tus objetivos de aprendizaje',
			description:
				'Cuéntanos qué estás construyendo y compartiremos mejores prácticas, plantillas y próximos pasos.',
			primaryCta: 'Escribir a {{brandName}}',
		},
	},
} satisfies LandingLocale

export default landing
